import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EntityCard } from "@/components/ui/entity-card";
import operator from "../../../images/operator.png";
import type { BadgeZoneViolationIncident, PedestrianDevice } from "src/api";

export type BadgeDetailsProps = {
    badgeLabel: string;
    title: string;
    incident?: BadgeZoneViolationIncident;
    pedestrianDevice?: PedestrianDevice;
    loading?: boolean;
};

export const BadgeDetails = ({
    badgeLabel,
    title,
    loading,
    incident,
    pedestrianDevice,
}: BadgeDetailsProps): JSX.Element => {
    return (
        <>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
                <EntityCard
                    loading={loading}
                    badgeLabel={badgeLabel}
                    // TODO: Change this to a badge image. AGV or Pedestrian badge.
                    image={operator}
                    badgeZoneViolationIncident={incident}
                    pedestrianDevice={pedestrianDevice}
                />
            </CardContent>
        </>
    );
};
